import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LogsIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M12.978 2.02895C12.9775 1.48583 12.7655 0.975532 12.3811 0.591994C11.5882 -0.199084 10.2993 -0.197993 9.5073 0.59497L1.32626 8.80895C1.06016 9.07486 0.857033 9.40404 0.738808 9.761L0.731171 9.78421L0 12.9995L3.22421 12.2777L3.24821 12.2697C3.60527 12.1515 3.93465 11.9486 4.20145 11.6819L12.3836 3.46689C12.7673 3.08266 12.9785 2.57197 12.978 2.02895ZM1.78796 11.5592L1.44608 11.2171L1.69294 10.1312L2.87648 11.3155L1.78796 11.5592ZM11.665 2.7502L3.72161 10.7255L2.28317 9.28621L7.7244 3.82316L8.55297 4.65172L9.27055 3.93414L8.4405 3.10408L9.21243 2.32917L10.044 3.16072L10.7616 2.44313L9.92853 1.6101L10.2258 1.31166C10.622 0.914932 11.2674 0.914337 11.6643 1.31037C11.8567 1.50239 11.9629 1.75788 11.9632 2.02974C11.9633 2.3017 11.8577 2.55729 11.665 2.7502ZM5.33858 11.9737H12.978V12.9885H4.32722L5.33858 11.9737Z"
    />
  </svg>
);

LogsIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

LogsIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(13, 13),
};

export default LogsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/logs-v1.js